import React from 'react';
import {
    toast, ToastContainer, MDBCard, MDBCardTitle, MDBCardText, MDBInput, MDBFormInline, MDBBadge, MDBContainer, MDBListGroup,
    MDBListGroupItem, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter
} from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Header from './ComponentFragments/Header';
import Colors from '../Styles/Colors';


export default class VSCart extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            cartData: [],
            dirty: false,
            stockLimitsData: [],
            qtyCheckModalOpen: false,
        }
        this.dl = new DataLayer();
        this.formatter = new Formatter();
        this.handleChange = this.handleChange.bind(this);
        this.resetCart = this.resetCart.bind(this);
        this.updateCart = this.updateCart.bind(this);
        this.checkout = this.checkout.bind(this);
        this.checkStockQtys = this.checkStockQtys.bind(this);
        this.zeroItem = this.zeroItem.bind(this);
        this.ApplyAvailableQtys = this.ApplyAvailableQtys.bind(this);
    }

    zeroItem(item){
        this.setQty(0, item);
    }

    ApplyAvailableQtys() {
        let cartData = this.state.cartData;
        let availableQtys = this.state.stockLimitsData;
        for (var i = 0; i < availableQtys.length; i++) {
            for (var x = 0; x < cartData.length; x++) {
                if (cartData[x].stockId == availableQtys[i].stockId) {
                    cartData[x].qty = availableQtys[i].qtyAssigned == -1 ? availableQtys[i].qty : availableQtys[i].availableToOrder
                    }
            }
        }

        this.setState({
            cartData,
            dirty: true,
            qtyCheckModalOpen: false
        })
    }

    async checkStockQtys() {
        this.props.loaderOn();
        let requestObject = {
            cartItemList: this.state.cartData
        }
        let response = await this.dl.Post("/common/CheckVSQuantities", requestObject, false);
        if (!response.errorOccurred) {
            if (response.otherInfo == 'true') {
                this.setState({
                    stockLimitsData: response.data,
                    qtyCheckModalOpen: true
                })
            } else {
                this.checkout();
            }
        } else {
            //this.setState({ errorModalOpen: true, cartErrorMsg: response.errorMessage });
            alert('Error Ocurred: ' + response.errorMessage)
        }
        this.props.loaderOff();
    }

    async checkout() {
        let requestObject = {
            cartItemList: this.state.cartData
        }
        let response = await this.dl.Post("/common/checkoutvscart", requestObject, false);

        if (response.errorOccurred) {

            toast.warning(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; An error occurred on Checkout. Please try again. </span>, {
                closeButton: false
            });
        } else {
            toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; Cart Checked Out. </span>, {
                closeButton: false
            });
            this.props.updateCartCount(response.data);
            this.setState({
                cartData: [],
                dirty: false
            });
        }
    }

    async updateCart() {
        
        if (this.state.cartData.length > 0) {
            this.props.loaderOn();
            let requestObject = {
                cartItemList: this.state.cartData
            }

            let response = await this.dl.Post("/common/updatevscart", requestObject, false);
            

            //***********************************************************
            if (response.errorOccurred) {

                toast.warning(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; Unable to order more than on hand. Please check cart quantities. </span>, {
                    closeButton: false
                });
            } else {
                toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; Cart Updated. </span>, {
                    closeButton: false
                });
            }
            response = await this.dl.Get('/common/getvscartitems?zoneId=' + this.props.getSelectedZoneId());
            this.setState({
                cartData: response.data,
                dirty: false
            });
            this.props.loaderOff();
        }
        
    }

    resetCart() {
        let cartData = this.state.cartData;

        cartData.forEach((item) => item.qty = item.originalQty);

        this.setState({
            cartData,
            dirty: false
        })
    }

    setQty(qty, item) {
        let cartData = this.state.cartData
        let index = -1;
        if (item.stockId != 0) {
            index = cartData.findIndex((i) =>
                i.stockId == item.stockId
            );

        } else {
            index = cartData.findIndex((i) =>
                i.shipStockId == item.shipStockId
            );
        }
        cartData[index].qty = qty

        let changedItems = cartData.some((i) => i.qty != i.originalQty);

        this.setState({
            cartData,
            dirty: changedItems
        })
    }

    handleChange(event, item) {
        let qty = event.target.valueAsNumber

        if (qty < 0) {
            qty = 1;
        }
        if (qty > 0) {
            if ((qty) > item.available) {
                toast.warning(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; Unable to order more than on hand.. </span>, {
                    closeButton: false
                });
                qty = item.originalQty;
            }
        }
        this.setQty(qty, item);
    }

    async componentWillMount(nextProps) {
        //get items in cart
        //let dl = new DataLayer();
        let response = await this.dl.Get('/common/getvscartitems?zoneId=' + this.props.getSelectedZoneId());
        this.setState({
            cartData: response.data
        });
        this.props.loaderOff();
    }


    render() {
        let itemsTotal = 0;
        return (
            <div>
                <Header headerText="Shopping Cart"
                    hideSearch={true}
                />
                <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                    <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}><MDBIcon icon="list-ul" />&nbsp;Items In Your Cart&nbsp;<MDBBadge color="purple">{this.state.cartData.length}</MDBBadge></MDBCardTitle>
                    <hr className="hr_grey" />
                    {
                        this.state.cartData.map((item, index) => {
                            itemsTotal += (item.price * item.qty) / 100;
                            return (
                                <div key={index}>
                                    <MDBRow className="mx-2" between>
                                        <MDBCol sm="12">
                                            <span style={{ color: Colors.purple, fontWeight: "bold" }}>{item.invoiceDescription}</span>
                                            <br />
                                        </MDBCol>
                                        <MDBCol md="6" sm="12">
                                            <MDBRow>
                                                <MDBCol>
                                                    <span style={{ fontSize: "14px" }}>Code: {item.processingCode}</span><br />
                                                    <span style={{ fontSize: "14px" }}>Price: {this.formatter.formatCurrency(item.price / 100)}</span><br />
                                                    <span style={{ fontSize: "14px" }}>QOH: {item.available}</span><br />
                                                </MDBCol>
                                                <MDBCol className="text-right">
                                                    <span style={{ fontSize: "14px", fontWeight: "bold" }}>Total: {this.formatter.formatCurrency((item.price * item.qty) / 100)}</span>
                                                </MDBCol>
                                            </MDBRow>
                                            <span className="cartRemoveItem" onClick={() => this.zeroItem(item)}><MDBIcon far icon="trash-alt" /> Remove Item</span>
                                        </MDBCol>
                                        <MDBCol md="3" sm="12">
                                            <MDBInput className="mb-0" type="number" label="Qty" value={item.qty} min={0} onChange={(event) => this.handleChange(event, item)} />
                                        </MDBCol>
                                    </MDBRow><hr className="hr_grey" />
                                </div>
                            );
                        })
                    }
                    <MDBRow>
                        <MDBCol sm="6" style={{ fontSize: "16px", fontWeight: "bold", display: "table" }}>
                            <div className="cartSummaryItem">Items Total:</div>
                            <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(itemsTotal)}</div>
                        </MDBCol>
                    </MDBRow>
                    <hr className="hr_grey" />
                    <MDBRow>
                        <MDBCol sm="12" style={{ fontSize: "16px", fontWeight: "bold", display: "table" }}>
                            <div className="text-center" hidden={!this.state.dirty}>
                                <MDBBtn rounded color="mdb-color" size="sm" onClick={this.resetCart}><MDBIcon icon="sync-alt" />&nbsp;Reset</MDBBtn>
                                <MDBBtn rounded color="pink" size="sm" onClick={this.updateCart}><MDBIcon icon="arrow-up" />&nbsp;Update</MDBBtn><br />
                                <span style={{ color: "black", fontSize: "14px" }}>Cart has changed, please update to checkout. <br />(Items with 0 quantity will be removed.)</span>
                            </div>
                            <div className="text-center"><MDBBtn rounded disabled={this.state.cartData.length == 0} hidden={this.state.dirty} color="purple" size="sm" onClick={this.checkStockQtys}><MDBIcon icon="shopping-cart" />&nbsp;Checkout</MDBBtn></div>
                        </MDBCol>
                    </MDBRow>
                </MDBCard>
                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />

                <MDBModal isOpen={this.state.qtyCheckModalOpen} toggle={this.state.qtyCheckModalOpen} centered>
                    <MDBModalHeader>Adjust Cart Quantities</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.stockLimitsData.map((item) => {
                            return (
                                <MDBRow>
                                    <MDBCol sm="12" md="6">
                                        <span style={{ fontWeight: "bold", fontSize: "12px" }}>{item.invoiceDescription}</span>
                                    </MDBCol>
                                    <MDBCol sm="12" md="3">
                                        <span style={{ fontWeight: "bold", fontSize: "12px" }}>Qty:&nbsp;{item.originalQty}</span>
                                    </MDBCol>
                                    <MDBCol sm="12" md="3">
                                        <span style={{ fontWeight: "bold", fontSize: "12px" }}>Available:&nbsp;{item.qtyAssigned == -1 ? item.qty : item.availableToOrder}</span>
                                    </MDBCol>
                                    <MDBCol sm="12">
                                        <hr className="hr_grey" />
                                    </MDBCol>
                                </MDBRow>

                            )
                        })}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.ApplyAvailableQtys}>Apply Qty's</MDBBtn>
                        <MDBBtn rounded color="secondary" onClick={() => this.setState({ qtyCheckModalOpen: false})}>Close</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>
            </div>
        );
    }
}